import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IconButton, Stack, TableContainer } from '@mui/material';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const CustomActions: React.ElementType<TablePaginationActionsProps> = (
    props
) => {
    const { page, onPageChange, count, rowsPerPage } = props;

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    return (
        <Stack flexDirection="row" alignItems="center">
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                <ChevronLeft />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                <ChevronRight />
            </IconButton>
        </Stack>
    );
};

export const TableWrapper: React.FC<TableProps> = (props) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const { t } = useTranslation();
    const rows = props.rows;

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        props.paginationHandle(event, newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        props.handleChangeRowsPerPage(event);
    };

    return (
        <TableContainer component={Paper}>
            {props.children}
            <TablePagination
                rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={t('TABLE_PAGINATOR.ROWS_PER_PAGE')}
                labelDisplayedRows={({ from, to, count }) => {
                    return t('TABLE_PAGINATOR.ROWS', {
                        from: from,
                        to: to,
                        count: count,
                    });
                }}
                showFirstButton
                showLastButton
                ActionsComponent={CustomActions}
            />
        </TableContainer>
    );
};

interface TableProps {
    children: React.ReactNode;
    rows: any;
    paginationHandle: (event: unknown, newPage: number) => void;
    handleChangeRowsPerPage: (event: unknown) => void;
}
